import React from 'react';
import { useTranslation } from 'react-i18next';
import uniqid from 'uniqid';
import { Box } from '@ktag/styleguide/dist/react';
import { ProfileData } from 'types/api.types';

interface Props {
  editStep: number;
  isSuccess: boolean;
  data?: ProfileData;
  isTimeout?: boolean;
}

const EditInfoBox = ({ editStep, isSuccess, data, isTimeout }: Props) => {
  const { t } = useTranslation('newsletter');

  const sortedData = data?.newsletters
    ?.slice()
    .sort((a, b) => a.name.localeCompare(b.name));

  if (editStep === 2) {
    return (
      <Box heading={t('edit_infobox_save_changes_title')}>
        <p>{t('edit_infobox_save_changes_text')}</p>
        <ul>
          {sortedData.map((item) => {
            return <li key={uniqid()}>{item.name}</li>;
          })}
        </ul>
      </Box>
    );
  }
  if (editStep === 3 && isSuccess) {
    return (
      <Box heading={t('edit_infobox_edit_successful_title')} type="positive">
        <p>{t('edit_infobox_edit_successful_text')}</p>
        <ul>
          {sortedData.map((item) => {
            return <li key={uniqid()}>{item.name}</li>;
          })}
        </ul>
      </Box>
    );
  }
  if (editStep === 3 && !isSuccess) {
    return (
      <Box heading={t('edit_infobox_edit_failed_title')} type="negative">
        <p>
          {isTimeout
            ? t('edit_infobox_edit_timeout_text')
            : t('edit_infobox_edit_failed_text')}
        </p>
      </Box>
    );
  }
  return null;
};

export default EditInfoBox;
